import React from 'react';
import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import JoinFacilityScreen from '../components/screens/facilities2/JoinFacilityScreen';

export default function FacilityJoin(props) {
  return (
    <Layout headerTitle="Join Facility">
      <PageContainer id="join_facility">
        <JoinFacilityScreen props={props} />
      </PageContainer>
    </Layout>
  );
}
